import Vue from "vue";
import { Country } from "@/shared/models/country";
import { Category } from "@/shared/models/category";
import { GetterTree, ActionTree, MutationTree } from "vuex";
import { ListModel } from "../../shared/models/listModel";
import { CardType } from "@/shared/models/cardType";
import { PropertyType } from "@/shared/models/propertyType";
import { PricingModel } from "@/shared/models/pricingModel";
import { AmenityGroup, AmenityView } from "@/shared/models/amenities";
import { Currency } from '@/shared/models/currency';
import { TaxRateView } from '@/shared/models/taxRates';
import { PriceCalculationMethodView } from '@/shared/models/priceCalculationMethods';
import { PoiTypeView } from '@/shared/models/poiType';
import { LanguageView } from '@/shared/models/languages';
import { BedType } from '@/shared/models/bedType';
import { CancelationPolicy } from '@/shared/models/cancelationPolicy';
import { PrepaymentPolicy } from '@/shared/models/prepaymentPolicy';
import { RoomType } from '@/shared/models/roomType';
import { PhotoTag } from "@/shared/models/photoTag";
import { DistributionChannelType } from "@/shared/models/distributionChannelType";
import { Ota } from "@/shared/models/ota";
import { ReservationStatus } from '@/shared/models/reservationStatus';
import { ReservationBillingStatus } from '@/shared/models/reservationStatus';
import { PaymentMean } from '@/shared/models/paymentMean';
import { FinancialDocumentType } from '@/shared/models/financialDocumentType';
import { FinancialDocumentStatus } from '@/shared/models/financialDocumentStatus';
import { UnitOfMeasureView } from "@/shared/models/unitOfMeasure";
import { SalesChannelView } from "@/shared/models/salesChannel";
import { CityTaxCategory } from "@/shared/models/cityTaxCategory";
import { ArrivalOrganizationType } from "@/shared/models/arrivalOrganizationType";
import { IdentificationDocumentType } from "@/shared/models/identificationDocumentType";
import { OwnerPricingModel } from "@/shared/models/ownerPricingModel";
import { MessageSourceType } from "@/shared/models/messageSourceType";
import { NotificationTemplateAttachment } from "@/shared/models/notificationTemplateAttachment";
import { NotificationTemplateRecipient } from "@/shared/models/notificationTemplateRecipient";
import { TemplateVariable } from "@/components/messages/templates/types";
import { NotificationSchedulesOffset } from "@/shared/models/notificationSchedulesOffset";
import { NotificationSchedulesTriggerDate } from "@/shared/models/notificationSchedulesTriggerDate";
import { AccomodationUnitStatus } from "@/shared/models/accomodationUnitStatus";
import { AgencyWorkModel } from "@/shared/models/agencyWorkModel";
import { VATCategoryForPrepayments } from "@/shared/models/vatCategoryForPrepayments";
import { DemandChangingEventStatus } from "@/shared/models/demandChangingEvent";
import { ServiceType } from "@/shared/models/serviceType";
import { ArrivalReason } from "@/shared/models/arrivalReason";
import { GuestReviewStatus } from "@/shared/models/guestReview";
import { AvailabilityChangelogEventType } from "@/shared/models/availabilityChangelogEventType";
import { RatePlansPromoCodeApplicationMethod } from "@/shared/models/ratePlansPromoCodeApplicationMethod"
import { TransactionType } from "@/shared/models/transactionType"
import { TransactionDescription } from "@/shared/models/transactionDescriptionCodebooks"
import { EVisitorFacilityStatus } from "@/shared/models/eVisitorFacilityStatus";

const initialState = {
  arrivalOrganizationTypes: [] as ArrivalOrganizationType[],
  cityTaxCategories: [] as CityTaxCategory[],
  countries: [] as Country[],
  languages: [] as LanguageView[],
  categories: [] as Category[],
  currencies: [] as Currency[],
  taxRates: [] as TaxRateView[],
  priceCalculationMethods: [] as PriceCalculationMethodView[],
  cardTypes: [] as CardType[],
  poiTypes: [] as PoiTypeView[],
  amenities: [] as AmenityView[],
  amenityGroups: [] as AmenityGroup[],
  propertyTypes: [] as PropertyType[],
  pricingModels: [] as PricingModel[],
  bedTypes: [] as BedType[],
  cancelationPolicies: [] as CancelationPolicy[],
  prepaymentPolicies: [] as PrepaymentPolicy[],
  roomTypes: [] as RoomType[],
  photoTags: [] as PhotoTag[],
  distributionChannelTypes: [] as DistributionChannelType[],
  otas: [] as Ota[],
  salesChannels: [] as SalesChannelView[],
  reservationStatuses: [] as ReservationStatus[],
  paymentMeans: [] as PaymentMean[],
  financialDocumentTypes: [] as FinancialDocumentType[],
  financialDocumentStatuses: [] as FinancialDocumentStatus[],
  identificationDocumentTypes: [] as IdentificationDocumentType[],
  ownerPricingModels: [] as OwnerPricingModel[],
  unitsOfMeasure: [
    { id: 1, name: "kom", textResourceKey: "t.UnitsOfMeasure.pcs" },
    { id: 2, name: "kpl", textResourceKey: "t.UnitsOfMeasure.cpl" },
    { id: 3, name: "usluga", textResourceKey: "t.UnitsOfMeasure.service" },
    { id: 4, name: "sat", textResourceKey: "t.UnitsOfMeasure.hour" },
    { id: 5, name: "dan", textResourceKey: "t.UnitsOfMeasure.day" },
    { id: 6, name: "m2", textResourceKey: "t.UnitsOfMeasure.m2" },
    { id: 7, name: "set", textResourceKey: "t.UnitsOfMeasure.set" },
  ] as UnitOfMeasureView[], // this doesn't need to be loaded from server...
  messageSourceTypes: [] as MessageSourceType[],
  notificationTemplateAttachments: [] as NotificationTemplateAttachment[],
  notificationTemplateRecipients: [] as NotificationTemplateRecipient[],
  notificationTemplateVariables: [] as TemplateVariable[],
  notificationSchedulesOffsets: [] as NotificationSchedulesOffset[],
  notificationSchedulesTriggerDates: [] as NotificationSchedulesTriggerDate[],
  accomodationUnitStatuses: [] as AccomodationUnitStatus[],
  agencyWorkModels: [] as AgencyWorkModel[],
  vatCategoriesForPrepayments: [] as VATCategoryForPrepayments[],
  demandChangingEventStatus: [] as DemandChangingEventStatus[],
  serviceTypes: [] as ServiceType[],
  arrivalReasons: [] as ArrivalReason[],
  guestReviewStatuses: [] as GuestReviewStatus[],
  availabilityChangelogEventTypes: [] as AvailabilityChangelogEventType[],
  ratePlansPromoCodeApplicationMethods: [] as RatePlansPromoCodeApplicationMethod[],
  transactionTypes: [] as TransactionType[],
  transactionDescriptions: [] as TransactionDescription[],
  reservationBillingStatuses: [] as ReservationBillingStatus[],
  eVisitorFacilityStatuses: [] as EVisitorFacilityStatus[]
};

const state = { ...initialState };

const getters: GetterTree<typeof state, any> = {
  arrivalOrganizationTypes: (state) => state.arrivalOrganizationTypes,
  cityTaxCategories: (state) => state.cityTaxCategories,
  countries: (state) => state.countries,
  languages: (state) => state.languages,
  categories: (state) => state.categories,
  currencies: (state) => state.currencies,
  taxRates: (state) => state.taxRates,
  priceCalculationMethods: (state) => state.priceCalculationMethods,
  cardTypes: (state) => state.cardTypes,
  poiTypes: (state) => state.poiTypes,
  propertyTypes: (state) => state.propertyTypes,
  pricingModels: (state) => state.pricingModels,
  bedTypes: (state) => state.bedTypes,
  cancelationPolicies: (state) => state.cancelationPolicies,
  prepaymentPolicies: (state) => state.prepaymentPolicies,
  roomTypes: (state) => state.roomTypes,
  amenities: (state) =>
    state.amenities.map((a) => ({
      ...a,
      amenityGroupName: state.amenityGroups.find((g) => g.id == a.amenityGroupId)?.textResourceKey,
      amenitySortOrder: state.amenityGroups.find((g) => g.id == a.amenityGroupId)?.sortOrder
    })),
  groupedAmenities: (state) =>
    state.amenityGroups.map((g) => ({
      ...g,
      amenities: state.amenities.filter((a) => a.amenityGroupId === g.id),
    })),
  photoTags: (state) => state.photoTags,
  distributionChannelTypes: (state) => state.distributionChannelTypes,
  otas: (state) => state.otas.filter(x => x.status),
  otasWithInactive: (state) => state.otas,
  salesChannels: (state) => state.salesChannels.filter(x => x.status),
  salesChannelsWithInactive: (state) => state.salesChannels,
  reservationStatuses: (state) => state.reservationStatuses,
  paymentMeans: (state) => state.paymentMeans,
  financialDocumentTypes: (state) => state.financialDocumentTypes,
  financialDocumentStatuses: (state) => state.financialDocumentStatuses,
  identificationDocumentTypes: (state) => state.identificationDocumentTypes,
  unitsOfMeasure: (state) => state.unitsOfMeasure,
  ownerPricingModels: (state) => state.ownerPricingModels,
  messageSourceTypes: (state) => state.messageSourceTypes,
  notificationTemplateAttachments: (state) => state.notificationTemplateAttachments,
  notificationTemplateRecipients: (state) => state.notificationTemplateRecipients,
  notificationTemplateVariables: (state) => state.notificationTemplateVariables,
  notificationSchedulesOffsets: (state) => state.notificationSchedulesOffsets,
  notificationSchedulesTriggerDates: (state) => state.notificationSchedulesTriggerDates,
  accomodationUnitStatuses: (state) => state.accomodationUnitStatuses,
  agencyWorkModels: (state) => state.agencyWorkModels,
  vatCategoriesForPrepayments: (state) => state.vatCategoriesForPrepayments,
  demandChangingEventStatus: (state) => state.demandChangingEventStatus,
  serviceTypes: (state) => state.serviceTypes,
  arrivalReasons: (state) => state.arrivalReasons,
  guestReviewStatuses: (state) => state.guestReviewStatuses,
  availabilityChangelogEventTypes: (state) => state.availabilityChangelogEventTypes,
  ratePlansPromoCodeApplicationMethods: (state) => state.ratePlansPromoCodeApplicationMethods,
  transactionTypes: (state) => state.transactionTypes,
  transactionDescriptions: (state) => state.transactionDescriptions,
  reservationBillingStatuses: (state) => state.reservationBillingStatuses,
  eVisitorFacilityStatuses: (state) => state.eVisitorFacilityStatuses
};

const actions: ActionTree<typeof state, any> = {
  refresharrivalOrganizationTypes({ commit }) {
    return Vue.axios
      .get<ListModel<ArrivalOrganizationType>>("codebooks/arrivalOrganizationTypes")
      .then((res) => {
        commit("setarrivalOrganizationTypes", res.data.result);
      });
  },
  refreshCityTaxCategories({ commit }) {
    return Vue.axios
      .get<ListModel<CityTaxCategory>>("codebooks/cityTaxCategories")
      .then((res) => {
        commit("setCityTaxCategories", res.data.result);
      });
  },
  refreshCountries({ commit }) {
    return Vue.axios
      .get<ListModel<Country>>("codebooks/countries")
      .then((res) => {
        commit("setCountries", res.data.result);
      });
  },
  refreshLanguages({ commit }) {
    return Vue.axios
      .get<ListModel<LanguageView>>("codebooks/languages")
      .then((res) => {
        commit("setLanguages", res.data.result);
      });
  },
  refreshCategories({ commit }) {
    return Vue.axios
      .get<ListModel<Category>>("codebooks/propertyCategories")
      .then((res) => {
        commit("setCategories", res.data.result);
      });
  },
  refreshCurrencies({ commit }) {
    return Vue.axios
      .get<ListModel<Currency>>("codebooks/currencies")
      .then((res) => {
        commit("setCurrencies", res.data.result);
      });
  },
  refreshTaxRates({ commit }) {
    return Vue.axios
      .get<ListModel<TaxRateView>>("codebooks/taxRates")
      .then((res) => {
        commit("setTaxRates", res.data.result);
      });
  },
  refreshPriceCalculationMethods({ commit }) {
    return Vue.axios
      .get<ListModel<PriceCalculationMethodView>>("codebooks/priceCalculationMethods")
      .then((res) => {
        commit("setPriceCalculationMethods", res.data.result);
      });
  },
  refreshCardTypes({ commit }) {
    return Vue.axios
      .get<ListModel<CardType>>("codebooks/cardTypes")
      .then((res) => {
        commit("setCardTypes", res.data.result);
      });
  },
  refreshPoiTypes({ commit }) {
    return Vue.axios
      .get<ListModel<PoiTypeView>>("codebooks/poiTypes", {
        params: {
          $orderby: "name asc"
        }
      })
      .then((res) => {
        commit("setPoiTypes", res.data.result);
      });
  },
  refreshAmenitiesAndGroups({ commit }) {
    return Promise.all([
      Vue.axios.get<ListModel<AmenityView>>("codebooks/amenities", {
        params: {
          $top: 1000,
          $orderby: "name asc"
        }
      }),
      Vue.axios.get<ListModel<AmenityGroup>>("codebooks/amenityGroups", {
        params: {
          $top: 1000,
          $orderby: "name asc"
        }
      }),
    ]).then((reses) => {
      commit("setAmenitiesAndGroups", {
        amenities: reses[0].data.result,
        groups: reses[1].data.result,
      });
    });
  },
  refreshPropertyTypes({ commit }) {
    return Vue.axios
      .get<ListModel<PropertyType>>("codebooks/propertyTypes")
      .then((res) => {
        commit("setPropertyTypes", res.data.result);
      });
  },
  refreshPricingModels({ commit }) {
    return Vue.axios
      .get<ListModel<PricingModel>>("codebooks/pricingModels")
      .then((res) => {
        commit("setPricingModels", res.data.result);
      });
  },
  refreshBedTypes({ commit }) {
    return Vue.axios
      .get<ListModel<BedType>>("codebooks/bedTypes")
      .then((res) => {
        commit("setBedTypes", res.data.result);
      });
  },
  refreshCancelationPolicies({ commit }) {
    return Vue.axios
      .get<ListModel<CancelationPolicy>>("codebooks/cancelationPolicies")
      .then((res) => {
        commit("setCancelationPolicies", res.data.result);
      });
  },
  refreshPrepaymentPolicies({ commit }) {
    return Vue.axios
      .get<ListModel<PrepaymentPolicy>>("codebooks/prepaymentPolicies")
      .then((res) => {
        commit("setPrepaymentPolicies", res.data.result);
      });
  },
  refreshRoomTypes({ commit }) {
    return Vue.axios
      .get<ListModel<RoomType>>("codebooks/roomTypes")
      .then((res) => {
        commit("setRoomTypes", res.data.result);
      });
  },
  refreshPhotoTags({ commit }) {
    return Vue.axios
      .get<ListModel<PhotoTag>>("codebooks/photoTags", {
        params: {
          $orderby: "name asc"
        }
      })
      .then((res) => {
        commit("setPhotoTags", res.data.result);
      });
  },
  refreshDistributionChannelTypes({ commit }) {
    return Vue.axios
      .get<ListModel<DistributionChannelType>>("codebooks/distributionChannelTypes")
      .then((res) => {
        commit("setDistributionChannelTypes", res.data.result);
      });
  },
  refreshOtas({ commit }) {
    return Vue.axios
      .get<ListModel<Ota>>("codebooks/otas", {
        params: {
          $orderby: "name asc"
        }
      })
      .then((res) => {
        commit("setOtas", res.data.result);
      });
  },
  refreshSalesChannels({ commit }) {
    return Vue.axios
      .get<ListModel<SalesChannelView>>("codebooks/salesChannels")
      .then((res) => {
        commit("setSalesChannels", res.data.result);
      });
  },
  refreshReservationStatuses({ commit }) {
    return Vue.axios
      .get<ListModel<ReservationStatus>>("codebooks/reservationStatuses")
      .then((res) => {
        commit("setReservationStatuses", res.data.result);
      });
  },
  refreshPaymentMeans({ commit }) {
    return Vue.axios
      .get<ListModel<PaymentMean>>("codebooks/paymentMeans")
      .then((res) => {
        commit("setPaymentMeans", res.data.result);
      });
  },
  refreshFinancialDocumentTypes({ commit }) {
    return Vue.axios
      .get<ListModel<FinancialDocumentType>>("codebooks/financialDocumentTypes")
      .then((res) => {
        commit("setFinancialDocumentTypes", res.data.result);
      });
  },
  refreshFinancialDocumentStatuses({ commit }) {
    return Vue.axios
      .get<ListModel<FinancialDocumentStatus>>("codebooks/financialDocumentStatuses")
      .then((res) => {
        commit("setFinancialDocumentStatuses", res.data.result);
      });
  },
  refreshIdentificationDocumentTypes({ commit }) {
    return Vue.axios
      .get<ListModel<IdentificationDocumentType>>("codebooks/identificationDocumentTypes")
      .then((res) => {
        commit("setIdentificationDocumentTypes", res.data.result);
      });
  },
  refreshOwnerPricingModels({ commit }) {
    return Vue.axios
      .get<ListModel<OwnerPricingModel>>("codebooks/ownerPricingModels")
      .then((res) => {
        commit("setOwnerPricingModels", res.data.result);
      });
  },
  refreshMessageSourceTypes({ commit }) {
    return Vue.axios
      .get<ListModel<MessageSourceType>>("codebooks/messageSourceTypes")
      .then((res) => {
        commit("setMessageSourceTypes", res.data.result);
      });
  },
  refreshNotificationTemplateAttachments({ commit }) {
    return Vue.axios
      .get<ListModel<NotificationTemplateAttachment>>("codebooks/notificationTemplateAttachments")
      .then((res) => {
        commit("setNotificationTemplateAttachments", res.data.result);
      });
  },
  refreshNotificationTemplateRecipients({ commit }) {
    return Vue.axios
      .get<ListModel<NotificationTemplateRecipient>>("codebooks/notificationTemplateRecipients")
      .then((res) => {
        commit("setNotificationTemplateRecipients", res.data.result);
      });
  },
  refreshNotificationTemplateVariables({ commit }) {
    return Vue.axios
      .get<ListModel<NotificationTemplateRecipient>>("notificationTemplates/getVariables")
      .then((res) => {
        commit("setNotificationTemplateVariables", res.data.result);
      });
  },
  refreshNotificationSchedulesOffsets({ commit }) {
    return Vue.axios
      .get<ListModel<NotificationSchedulesOffset>>("codebooks/notificationSchedulesOffsets")
      .then((res) => {
        commit("setNotificationSchedulesOffsets", res.data.result);
      });
  },
  refreshNotificationSchedulesTriggerDates({ commit }) {
    return Vue.axios
      .get<ListModel<NotificationSchedulesTriggerDate>>("codebooks/notificationSchedulesTriggerDates")
      .then((res) => {
        commit("setNotificationSchedulesTriggerDates", res.data.result);
      });
  },
  refreshAccomodationUnitStatuses({ commit }) {
    return Vue.axios
      .get<ListModel<AccomodationUnitStatus>>("codebooks/accomodationUnitStatuses")
      .then((res) => {
        commit("setAccomodationUnitStatuses", res.data.result);
      });
  },
  refreshAgencyWorkModels({ commit }) {
    return Vue.axios
      .get<ListModel<AgencyWorkModel>>("codebooks/agencyWorkModels")
      .then((res) => {
        commit("setAgencyWorkModels", res.data.result);
      });
  },
  refreshVATCategoriesForPrepayments({ commit }) {
    return Vue.axios
      .get<ListModel<VATCategoryForPrepayments>>("codebooks/vatCategoriesForPrepayments")
      .then((res) => {
        commit("setVATCategoriesForPrepayments", res.data.result)
      });
  },
  refreshDemandChangingEventStatus({ commit }) {
    return Vue.axios
      .get<ListModel<DemandChangingEventStatus>>("codebooks/demandChangingEventStatus")
      .then((res) => {
        commit("setDemandChangingEventStatus", res.data.result)
      });
  },
  refreshServiceTypes({ commit }) {
    return Vue.axios
      .get<ListModel<ServiceType>>("codebooks/serviceTypes")
      .then((res) => {
        commit("setServiceTypes", res.data.result)
      });
  },
  refreshArrivalReasons({ commit }) {
    return Vue.axios
      .get<ListModel<ArrivalReason>>("codebooks/arrivalReasons")
      .then((res) => {
        commit("setArrivalReasons", res.data.result)
      });
  },
  refreshGuestReviewStatuses({ commit }) {
    return Vue.axios
      .get<ListModel<GuestReviewStatus>>("codebooks/guestReviewStatuses")
      .then((res) => {
        commit("setGuestReviewStatuses", res.data.result);
      });
  },
  refreshAvailabilityChangelogEventTypes({ commit }) {
    return Vue.axios
      .get<ListModel<AvailabilityChangelogEventType>>("codebooks/availabilityChangelogEventTypes")
      .then((res) => {
        commit("setAvailabilityChangelogEventTypes", res.data.result);
      });
  },
  refreshRatePlansPromoCodeApplicationMethods({ commit }) {
    return Vue.axios.get<ListModel<RatePlansPromoCodeApplicationMethod>>("codebooks/ratePlansPromoCodeApplicationMethods")
      .then((res) => {
        commit("setRatePlansPromoCodeApplicationMethods", res.data.result);
      })
  },
  refreshTransactiontypes({ commit }) {
    return Vue.axios
      .get<ListModel<TransactionType>>("codebooks/transactionTypes")
      .then((res) => {
        commit("setTransactionTypes", res.data.result);
      });
  },
  refreshTransactiontypeDescriptions({ commit }) {
    return Vue.axios
      .get<ListModel<TransactionDescription>>("codebooks/transactionDescriptions")
      .then((res) => {
        commit("setTransactionDescriptions", res.data.result);
      });
  },
  refreshReservationBillingStatuses({ commit }) {
    return Vue.axios
      .get<ListModel<ReservationBillingStatus>>("codebooks/reservationBillingStatuses")
      .then((res) => {
        commit("setReservationBillingStatuses", res.data.result);
      });
  },
  refreshEVisitorFacilityStatuses({ commit }) {
    return Vue.axios
      .get<ListModel<EVisitorFacilityStatus>>("codebooks/eVisitorFacilityStatuses")
      .then((res) => {
        commit("setEVisitorFacilityStatuses", res.data.result);
      })
  }
};
const mutations: MutationTree<typeof state> = {
  reset: (state) => {
    Object.assign(state, initialState);
  },
  setarrivalOrganizationTypes: (state, value) => {
    state.arrivalOrganizationTypes = value.slice();
  },
  setCityTaxCategories: (state, value) => {
    state.cityTaxCategories = value.slice();
  },
  setCountries: (state, value) => {
    state.countries = value.slice();
  },
  setLanguages: (state, value) => {
    state.languages = value.slice();
  },
  setCategories: (state, value) => {
    state.categories = value.slice();
  },
  setCurrencies: (state, value) => {
    state.currencies = value.slice();
  },
  setTaxRates: (state, value) => {
    state.taxRates = value.slice();
  },
  setPriceCalculationMethods: (state, value) => {
    state.priceCalculationMethods = value.slice();
  },
  setCardTypes: (state, value) => {
    state.cardTypes = value.slice();
  },
  setPoiTypes: (state, value) => {
    state.poiTypes = value.slice();
  },
  setAmenitiesAndGroups: (
    state,
    value: { amenities: AmenityView[]; groups: AmenityGroup[] }
  ) => {
    state.amenities = value.amenities.slice();
    state.amenityGroups = value.groups.slice();
  },
  setPropertyTypes: (state, value) => {
    state.propertyTypes = value.slice();
  },
  setPricingModels: (state, value) => {
    state.pricingModels = value.slice();
  },
  setBedTypes: (state, value) => {
    state.bedTypes = value.slice();
  },
  setCancelationPolicies: (state, value) => {
    state.cancelationPolicies = value.slice();
  },
  setPrepaymentPolicies: (state, value) => {
    state.prepaymentPolicies = value.slice();
  },
  setRoomTypes: (state, value) => {
    state.roomTypes = value.slice();
  },
  setPhotoTags: (state, value) => {
    state.photoTags = value.slice();
  },
  setDistributionChannelTypes: (state, value) => {
    state.distributionChannelTypes = value.slice();
  },
  setOtas: (state, value) => {
    state.otas = value.slice();
  },
  setSalesChannels: (state, value) => {
    state.salesChannels = value.slice();
  },
  setReservationStatuses: (state, value) => {
    state.reservationStatuses = value.slice();
  },
  setPaymentMeans: (state, value) => {
    state.paymentMeans = value.slice();
  },
  setFinancialDocumentTypes: (state, value) => {
    state.financialDocumentTypes = value.slice();
  },
  setFinancialDocumentStatuses: (state, value) => {
    state.financialDocumentStatuses = value.slice();
  },
  setOwnerPricingModels: (state, value) => {
    state.ownerPricingModels = value.slice();
  },
  setIdentificationDocumentTypes: (state, value) => {
    state.identificationDocumentTypes = value.slice();
  },
  setMessageSourceTypes: (state, value) => {
    state.messageSourceTypes = value.slice();
  },
  setNotificationTemplateAttachments: (state, value) => {
    state.notificationTemplateAttachments = value.slice();
  },
  setNotificationTemplateRecipients: (state, value) => {
    state.notificationTemplateRecipients = value.slice();
  },
  setNotificationTemplateVariables: (state, value) => {
    state.notificationTemplateVariables = value.slice();
  },
  setNotificationSchedulesOffsets: (state, value) => {
    state.notificationSchedulesOffsets = value.slice();
  },
  setNotificationSchedulesTriggerDates: (state, value) => {
    state.notificationSchedulesTriggerDates = value.slice();
  },
  setAccomodationUnitStatuses: (state, value) => {
    state.accomodationUnitStatuses = value.slice();
  },
  setAgencyWorkModels: (state, value) => {
    state.agencyWorkModels = value.slice();
  },
  setVATCategoriesForPrepayments: (state, value) => {
    state.vatCategoriesForPrepayments = value.slice();
  },
  setDemandChangingEventStatus: (state, value) => {
    state.demandChangingEventStatus = value.slice();
  },
  setServiceTypes: (state, value) => {
    state.serviceTypes = value.slice();
  },
  setArrivalReasons: (state, value) => {
    state.arrivalReasons = value.slice();
  },
  setGuestReviewStatuses: (state, value) => {
    state.guestReviewStatuses = value.slice();
  },
  setAvailabilityChangelogEventTypes: (state, value) => {
    state.availabilityChangelogEventTypes = value.slice();
  },
  setRatePlansPromoCodeApplicationMethods: (state, value) => {
    state.ratePlansPromoCodeApplicationMethods = value.slice();
  },
  setTransactionTypes: (state, value) => {
    state.transactionTypes = value.slice();
  },
  setTransactionDescriptions: (state, value) => {
    state.transactionDescriptions = value.slice();
  },
  setReservationBillingStatuses: (state, value) => {
    state.reservationBillingStatuses = value.slice();
  },
  setEVisitorFacilityStatuses: (state, value) => {
    state.eVisitorFacilityStatuses = value.slice();
  }
};

export default {
  namespaced: true,
  state: () => state,
  getters,
  actions,
  mutations,
};
